// src/pages/produtos/produtos/ApresentacaoTab.js
import { useEffect, useState } from 'react';
import Input from '../../../components/input/Input';
import ApresentacaoCad from '../combos/ApresentacaoCad';
import ApresentacaoSearch from '../combos/ApresentacaoSearch';
import { ProdutoApresentacao } from '../../../models/produtos/combos/ProdutoApresentacao';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import { useProdutoApresentacao } from '../../../contexts/produtos/combos/ProdutoApresentacaoContext';
import { IoMdAddCircle } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';

const ApresentacaoTab = ({ produto, disableCampos }) => {
  const { showYesNo } = useYesNo();
  const {
    produtoApresentacoes,
    fetchProdutoApresentacoes,
    addProdutoApresentacao,
    updateProdutoApresentacao,
    deleteProdutoApresentacao,
  } = useProdutoApresentacao();
  const [produtoApresentacao, setProdutoApresentacao] = useState(new ProdutoApresentacao());

  const [showApresentacaoCad, setShowApresentacaoCad] = useState(false);
  const [showSearchApresentacao, setShowSearchApresentacao] = useState(false);

  useEffect(() => {
    setProdutoApresentacao(new ProdutoApresentacao());
    fetchProdutoApresentacoes(produto.id);
  }, [produto.id]);

  const handleRemoveProdutoApresentacao = async (item) => {
    const resposta = await showYesNo("Deseja remover a apresentação?");
    if (resposta) {
      await deleteProdutoApresentacao(item.id);
    }
  };

  const handleSelectApresentacao = (apresentacaoSel) => {
    setProdutoApresentacao({
      ...produtoApresentacao,
      apresentacaoId: apresentacaoSel.id,
      apresentacao: apresentacaoSel,
    });
    setShowSearchApresentacao(false);
  };

  const handleSalvarProdutoApresentacao = (e) => {
    e.preventDefault();
    const payload = {
      ...produtoApresentacao,
      produtoId: produto.id,
    };
    delete payload.produto;
    delete payload.apresentacao;
    

    addProdutoApresentacao(payload);
  };

  const handleToggleAtivo = async (item) => {
    const payload = {
      ...item,
      ativo: !item.ativo,
      produtoId: produto.id,
    };
    delete payload.produto;
    delete payload.apresentacao;

    await updateProdutoApresentacao(payload);
  };


  return (
    <div>
      <div className="input-group" style={{ marginBottom: '10px', alignItems: 'end' }}>
        <Input
          label="Apresentação"
          value={produtoApresentacao.apresentacaoId || ''}
          onChange={(e) =>
            setProdutoApresentacao({ ...produtoApresentacao, apresentacaoId: e.target.value })
          }
          disabled={disableCampos}
          btnBuscarDisabled={disableCampos}
          btnAddDisabled={disableCampos}
          btnBuscar={() => setShowSearchApresentacao(true)}
          btnAdd={() => setShowApresentacaoCad(true)}
        />
        <Input
          value={produtoApresentacao.apresentacao?.nome || ''}
          size={300}
          disabled
        />
        {produto?.id > 0 && (
          <div style={{ marginTop: '8px' }}>
            <button className="btn btn-secondary" onClick={handleSalvarProdutoApresentacao}>
              <IoMdAddCircle /> Adicionar
            </button>
          </div>
        )}
      </div>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th style={{ width: '80px' }}>Código</th>
              <th>Descrição</th>
              <th style={{ width: '120px' }}>Valor Adicional</th>
              <th style={{ width: '80px' }}>Ativo</th>
              <th style={{ width: '80px' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {produtoApresentacoes.map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'right' }}>{item.apresentacaoId}</td>
                <td>{item.apresentacao?.nome}</td>
                <td style={{ textAlign: 'right' }}>
                  R$ {item.apresentacao?.valorAdicional?.toFixed(2)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <input
                    type="checkbox"
                    checked={item.ativo}
                    onChange={() => handleToggleAtivo(item)}
                  />
                </td>
                <td style={{ textAlign: 'center' }}>
                  <button
                    type="button"
                    style={{
                      backgroundColor: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '15%',
                      padding: '4px 8px',
                      cursor: 'pointer',
                    }}
                    onClick={() => handleRemoveProdutoApresentacao(item)}
                  >
                    <MdDelete />
                  </button>
                </td>
              </tr>
            ))}
            {produtoApresentacoes.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  Nenhuma apresentação cadastrada
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <ApresentacaoCad
        show={showApresentacaoCad}
        onHide={() => setShowApresentacaoCad(false)}
      />
      <ApresentacaoSearch
        show={showSearchApresentacao}
        onHide={() => setShowSearchApresentacao(false)}
        onSelectApresentacao={handleSelectApresentacao}
      />
    </div>
  );
};

export default ApresentacaoTab;